import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { ActivityDataProvider } from "../../data-provider/activity.dp";
import { AppTypeDataProvider } from "../../data-provider/app-type.dp";
import { EffortDataProvider } from "../../data-provider/effort.dp";
import { LogsDataProvider } from "../../data-provider/logs.dp";
import { Filter } from "../../models/filter.model";
import { User } from "../../models/user.model";
import { PermissionCheck } from "../../shared/permission";
import { ResultDataProvider } from "../../data-provider/result.dp";
import { TeamDataProvider } from "../../data-provider/team.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { UserDataProvider } from "../../data-provider/user.dp";
import { Utils } from "../../helper/utils.helper";
import { Dashboard } from "../../models/dashboard.model";
import { DashboardDataProvider } from "../../data-provider/dashboard.dp";
import { DashboardWidgetFilter } from "../../models/dashboard-widget-filter.model";

let UserInfoComponent = {
    selector: "vcUserInfo",
    templateUrl: "/angular/components/user/user-info.component.html",
    bindings: {
        userId: "=?",
    },
    controller: class UserInfoController {
        private readonly $scope: any;
        private readonly $rootScope: any;
        private $window: any;
        private $routeParams: any;
        private dataProvider: UserDataProvider;
        private dialog: DialogUtils;
        private toast: ToastUtils;
        private activityDataProvider: ActivityDataProvider;
        private teamDataProvider: TeamDataProvider;
        private campaignDataProvider: CampaignDataProvider;
        private dashboardDataProvider: DashboardDataProvider;
        private utils: Utils;

        public __env: any;
        public downloading: boolean;
        public logsDataProvider: LogsDataProvider;
        public permissionProvider: PermissionCheck;
        public user: any;
        public userId: any;
        public signedInUser: any;
        public filter?: DashboardWidgetFilter;
        public activeTab: any;
        public activeCampaign: any;
        public localStorage: any;
        public dateRange: any;
        public efforts?: any;
        public dashboards: Dashboard[];
        public dashboard: Dashboard;
        public loadingDashboard: boolean = true;
        public mode: string;

        constructor(
            $scope: any,
            $rootScope: any,
            $window: any,
            $routeParams: any,
            __env: any,
            UserDataProvider: UserDataProvider,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            LogsDataProvider: LogsDataProvider,
            ActivityDataProvider: ActivityDataProvider,
            TeamDataProvider: TeamDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            PermissionCheck: PermissionCheck,
            DashboardDataProvider: DashboardDataProvider,
            Utils: Utils
        ) {
            this.$scope = $scope;
            this.$rootScope = $scope;
            this.$window = $window;
            this.dataProvider = UserDataProvider;
            this.$routeParams = $routeParams;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.logsDataProvider = LogsDataProvider;
            this.activityDataProvider = ActivityDataProvider;
            this.teamDataProvider = TeamDataProvider;
            this.campaignDataProvider = CampaignDataProvider;
            this.permissionProvider = PermissionCheck;
            this.__env = __env;
            this.dashboardDataProvider = DashboardDataProvider;
            this.utils = Utils;
            this.user = null;
            this.activeCampaign = this.campaignDataProvider.getActiveCampaign();
            this.localStorage = this.activeCampaign.getLocalStorage();
            this.loadDashboards();
        }

        loadDashboards() {
            this.dashboardDataProvider
                .user()
                .then((dashboards: Dashboard[]): void => {
                    this.dashboards = dashboards;
                    let selectedDash: Dashboard = this.dashboards[0];
                    if (
                        this.localStorage &&
                        this.localStorage.userPage &&
                        this.localStorage.userPage.selectedDashboardId
                    ) {
                        angular.forEach(this.dashboards, (dash) => {
                            if (
                                dash.id ==
                                this.localStorage.userPage.selectedDashboardId
                            ) {
                                selectedDash = dash;
                            }
                        });
                    }
                    this.switchDashboard(selectedDash);
                });
        }

        switchDashboard(dashboard: Dashboard): void {
            if (!this.dashboard || dashboard.id != this.dashboard.id) {
                this.dashboard = dashboard;
            }
        }

        $onInit() {
            this.mode = this.userId ? "home_page" : "user_page";
            this.userId = this.userId ?? this.$routeParams.userId;
            this.signedInUser = this.dataProvider.getActiveUser();
            this.activeTab = "analytics";

            this.activeCampaign = this.campaignDataProvider.getActiveCampaign();
            this.localStorage = this.activeCampaign.getLocalStorage();
            this.logsDataProvider.setFilters(new Filter({ uid: this.userId }));

            this.utils.accessCheck();
            this.activityDataProvider.clearAll();
            this.logsDataProvider.setFilters(new Filter({ uid: this.userId }));

            this.dataProvider.getUser(this.userId).then((user) => {
                this.filter = new DashboardWidgetFilter();
                this.filter.dateRange = {};
                this.filter.users = [
                    {
                        uid: user.uid,
                        uemail: user.uemail,
                        ufname: user.ufname,
                        ulname: user.ulname,
                    },
                ];

                if (!user.teams) {
                    user.teams = [];
                    this.teamDataProvider.getAllTeams().then((teams) => {
                        angular.forEach(teams, (team, index) => {
                            if (team.hasMember(user)) user.teams.push(team);
                        });
                    });
                }
                this.user = user;
            });
        }

        changePhoto($event: any): void {
            let parentEl = angular.element(document.body);
            this.dialog
                .show({
                    parent: parentEl,
                    component: "vc-image-crop-dialog",
                    targetEvent: $event,
                    scope: this.$rootScope,
                    ariaLabel: "Image Crop",
                    size: "auto",
                })
                .then((returnedUser: User) => {
                    this.$window.location.reload();
                });
        }

        filterDashboards(accessType: string): Dashboard[] {
            if (this.dashboards) {
                if (accessType == "private") {
                    return this.dashboards.filter((dashboard: Dashboard) => {
                        return dashboard.uid != null;
                    });
                } else {
                    return this.dashboards.filter((dashboard: Dashboard) => {
                        return dashboard.uid == null;
                    });
                }
            }
            return [];
        }

        deleteUserModal(user: User, $event: any): void {
            this.dialog
                .delete({
                    fullscreen: true,
                    targetEvent: $event,
                    skipHide: true,
                    locals: {
                        title: `Delete User?`,
                    },
                })
                .then(() => {
                    this.dataProvider.removeUser(user).then(
                        () => {
                            this.toast.success("User Deleted");
                            this.teamDataProvider.clearAll();
                            this.dataProvider.clearAll();
                            this.$window.location = "/#/users";
                        },
                        () => this.toast.error()
                    );
                });
        }

        openUserInviteModal(event: any): void {
            this.dialog
                .show({
                    component: "vc-update-user-dialog",
                    targetEvent: event,
                    clickOutsideToClose: false,
                    scope: this.$scope,
                    locals: {
                        user: this.user,
                    },
                })
                .then(() => {
                    this.teamDataProvider.clearAll();
                    this.dataProvider.clearAll();
                });
        }

        openViewFilterDialog(filters: any, $event: any): void {
            this.dialog.show({
                component: "vc-view-filter-dialog",
                targetEvent: $event,
                scope: this.$scope,
                clickOutsideToClose: true,
                ariaLabel: "View Person",
                locals: {
                    filters: filters,
                },
            });
        }
    },
};

angular.module("user").component(UserInfoComponent.selector, UserInfoComponent);
